import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {getInnerRadius} from "./studioUtility";

@inject('looperStore')
@observer
class StudioPlayer extends Component {


    render() {
        const {looperStore} = this.props;
        if (!looperStore.isLooperPlaying  || looperStore.countDownValue === 0) {
            return null;
        }
        return (
            <g className="studio-player">
                <circle className="studio-cursor-base" style={{fill: 'white'}} x={0} y={0} r={getInnerRadius(0)}/>
                <text className="studio-player-countdown">{looperStore.countDownValue}</text>
            </g>
        );
    }
}

StudioPlayer.propTypes = {
    onClick: PropTypes.func,
    mobileView: PropTypes.bool,
};

export default StudioPlayer;
